import { client } from '@/services/api/axios.ts';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useDeleteEventRulesMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: object | undefined) => void;
  } = {
    onSuccess: () => {},
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ eventRuleIds }: { eventRuleIds: string[] }) => {
      return toast.promise(
        client.delete(`/events/rules`, {
          data: { eventRuleIds },
        }),
        {
          loading: 'Deleting event rules...',
          success: 'Successfully deleted the event rules.',
          error: (_: unknown) => `Uh oh, there was an error with deleting the event rules.`,
        }
      );
    },
    onSuccess: (data) => {
      if (data) {
        onSuccess?.(data);
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['event-rules'] });
    },
  });
};
